import { COLORS } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled from "styled-components";

export const DevicesTableWrapper = styled.div`
    margin: 0 ${toRem(-16)};
    @media (width < ${toEm(992)}) {
        padding-bottom: ${toRem(56)};
    }
    max-height: 100%;
    min-height: 100%;
    
    @media screen and (max-width: 992px) {
        background: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    }
`;



export const DevicesMobileWrapper = styled.div`
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 100%;
`;

export const DevicesMobileItem = styled.div`
    display: grid;
    background: ${COLORS.BG.SURFACE1};
    padding: 16px;
    position: relative;
    border-radius: 16px;
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-rows: 20px 20px 24px; 
    grid-template-areas:
    "title title     voltage     voltage"
    "updated updated updated updated"
    "hiveNumber disable disable disable";

    gap: ${toRem(2)} ${toRem(8)};
    transition: all .3s ease 0s;
`;

export const DeviceMobileItemTitle = styled.h4`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    grid-area: title;
    
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`

export const DeviceMobileItemVoltage = styled.div`
    grid-area: voltage;
    margin-left: auto;
`

export const DeviceMobileItemUpdated = styled.div`
    grid-area: updated;

    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 10px;
`

export const DeviceMobileItemHive = styled.div`
    grid-area: hiveNumber;
`

export const DeviceMobileItemDisable = styled.div`
    grid-area: disable;
    margin-left: auto;
`

export const DevicesMobileIcon = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: 24px;
    height: 24px;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const DeviceRemoveContent = styled.div`
    width: 100%;
    display: flex;
    padding: 16px;
    flex-direction: column;
    height: max-content;
    border-radius: 16px;
    background: ${COLORS.BG.SURFACE1};
`

export const DeviceRemoveContentColF = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
    
    
    h3 {
        color: var(--fg-default, rgba(16, 24, 40, 1));

        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0px;
        text-align: left;
    }
    
    svg {
        cursor: pointer;
    }
`

export const DeviceRemoveContentColButtons = styled.div`
    display: flex;
    gap: 12px;
    
    > * {
        width: 100%;
    }
`

export const DevicesEmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${toRem(80)} ${toRem(20)};
    min-height: ${toRem(400)};
    text-align: center;
    gap: ${toRem(16)};
`;

export const DevicesEmptyStateTitle = styled.h2`
    margin: 0;
    font-size: ${toRem(24)};
    font-weight: 700;
    line-height: ${32 / 24};
    color: ${COLORS.FG.DEFAULT};
`;

export const DevicesEmptyStateSubtitle = styled.p`
    margin: 0;
    font-size: ${toRem(14)};
    font-weight: 400;
    line-height: ${20 / 14};
    color: ${COLORS.FG.MUTED};
`;